/*
  <p
    color={color}
    size={size} 
    className={className}
  />
  - - - - - - - - - - - - -
  color -> white / black
  size -> xl / lg / md / sm / xs
  className -> css classes
  - - - - - - - - - - - - -
*/

export default function Label({ color, className, size, children, ...props }) {
  return (
    <p className={`label tc-${color} label--${size} ${className}`} {...props}>
      {children}
    </p>
  );
}

Label.defaultProps = {
  color: "black",
  size: "md",
  className: "",
};
